<template>
    <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <inertia-link :href="$route('home')">
                <img alt="Logo" class="mx-auto h-12 w-auto" src="/images/logo.png" />
            </inertia-link>
            <h2 class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
                {{ $t('signup.title') }}
            </h2>
            <p>
                {{ $t('signup.description') }}
            </p>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form @submit.prevent="submit">
                    <ui-input
                        :label="$t('signup.name')"
                        name="name"
                        required
                        v-model="form.name"
                    >
                        <div class="text-sm text-red-500" v-if="form.errors.name">
                            {{ $t(form.errors.name[0]) }}
                        </div>
                    </ui-input>
                    <ui-input
                        class="mt-4"
                        :label="$t('signup.email')"
                        name="email"
                        type="email"
                        required
                        v-model="form.email"
                    >
                        <div class="text-sm text-red-500" v-if="form.errors.email">
                            {{ $t(form.errors.email[0]) }}
                        </div>
                    </ui-input>
                    <ui-input
                        class="mt-4"
                        :label="$t('signup.password')"
                        name="password"
                        type="password"
                        autocomplete="new-password"
                        required
                        v-model="form.password"
                    >
                        <div class="text-sm text-red-500" v-if="form.errors.password">
                            {{ $t(form.errors.password[0]) }}
                        </div>
                    </ui-input>
                    <ui-input
                        class="mt-4"
                        :label="$t('signup.password_confirmation')"
                        name="password_confirmation"
                        type="password"
                        autocomplete="new-password"
                        required
                        v-model="form.password_confirmation"
                    />

                    <div class="mt-4">
                        <activix-button
                            :w-full="true"
                            :loading="form.processing"
                            color="indigo"
                            type="submit"
                        >
                            {{ $t('forms.button.signup') }}
                        </activix-button>
                    </div>
                </form>

                <div class="mt-6" v-if="false">
                    <div class="relative">
                        <div class="absolute inset-0 flex items-center">
                            <div class="w-full border-t border-gray-300" />
                        </div>
                        <div class="relative flex justify-center text-sm leading-5">
                            <span class="px-2 bg-white text-gray-500">
                                {{ $t('signup.signup_with') }}
                            </span>
                        </div>
                    </div>

                    <div class="mt-6 grid grid-cols-3 gap-3">
                        <div>
                            <span class="w-full inline-flex rounded-md shadow-sm">
                                <button aria-label="Sign in with Facebook" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" type="button">
                                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path
                                        d="M18.13,7.75H13.87V5.84a1,1,0,0,1,1-1.1h3v-4H13.54c-3.93,0-4.67,3-4.67,4.86V7.75h-3v4h3v11.5h5V11.75h3.85Z"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /></svg>
                                </button>
                            </span>
                        </div>

                        <div>
                            <span class="w-full inline-flex rounded-md shadow-sm">
                                <button aria-label="Sign in with Linkedin" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" type="button">
                                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path
                                        d="M5.67,22.63H.81V8.7H5.67Zm10.09-9.39a2.14,2.14,0,0,0-2.14,2.14v7.25H8.51V8.7h5.11v1.59a6.76,6.76,0,0,1,4.28-1.6c3.17,0,5.37,2.35,5.37,6.81v7.13H17.9V15.38A2.14,2.14,0,0,0,15.76,13.23Zm-10-9.36a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,5.74,3.88Z"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /></svg>
                                </button>
                            </span>
                        </div>

                        <div>
                            <span class="w-full inline-flex rounded-md shadow-sm">
                                <button aria-label="Sign in with Google" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" type="button">
                                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path
                                        d="M18.1,14.7H13.47V10.53h9.78v2.06a11.27,11.27,0,1,1-3-8.29L16.85,7.43A6.61,6.61,0,0,0,12,5.33,6.67,6.67,0,1,0,18.1,14.7Z"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /><path
                                        d="M6.18 8.71L2.59 5.84"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /><path
                                        d="M6.19 15.32L2.75 18.42"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /><path
                                        d="M15.92 17.39L18.99 20.84"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /></svg>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ActivixButton from '@/components/ui/ActivixButton.vue';
    import UiInput from '@/components/ui/UiInput.vue';

    export default {
        components: {
            UiInput,
            ActivixButton,
        },

        props: {
            account: {
                type: Object,
                default: () => {},
            },
        },

        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    email: this.account.email,
                    password: null,
                    password_confirmation: null,
                }),
            };
        },

        methods: {
            submit() {
                this.form.post(this.$route());
            },
        },
    };
</script>
